// eslint-disable-next-line import/prefer-default-export
export { unstable_ClassNameGenerator } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/className/index.js
// module id = 2218
// module chunks = 0